// src/components/PP2Exams.js
import React from 'react';

import ExamsList from './ExamsListPerYear';

const PP2Exams = ({ isLoggedIn, clearToken }) => {
    const items = [
        { name: 'PP2 EXAMS 2026 EXAMS', year: 2026, bgColor: 'rgba(0, 0, 0, 0.2)', textColor: 'rgb(0, 0, 0)', path: "pre/primary", value: "pp2/exams" },
        { name: 'PP2 EXAMS 2025 EXAMS', year: 2025, bgColor: 'rgba(0, 0, 0, 0.1)', textColor: 'rgb(0, 0, 0)', path: "pre/primary", value: "pp2/exams" },

    ];

    return (
       <>
      
        <ExamsList
           
            heading="PP2 EXAMS"
            items={items}
            navigateTo="/pp2/exams/download"
        />
       </>
    );
};

export default PP2Exams;
